export default {
      id: "arrow-up-usage",
      viewBox: "0 0 33 31",
      url: __webpack_public_path__ + "svg/sprite.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }